<template>
    <b-dropdown
        :class="{'placeholder-label': label === false }"
        :disabled="disabled"
        :menu-class="menuClass"
        :no-caret="noCaret"
        :right="right"
        :size="size"
        :text="text"
        :variant="(outline ? 'outline-' : '') + color"
        @click="$emit('click', $event)"
        v-bind="dropPosition"
    >
        <slot name="button-content" slot="button-content" />
        <slot />
    </b-dropdown>
</template>

<script>
import { BDropdown } from 'bootstrap-vue'

export default {
    components: { BDropdown },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        dropPosition() {

            if(this.position == 'left')
                return { dropleft: true }
            else if (this.potision == 'right')
                return { dropright: true }
            else if(this.potision == 'up')
                return { dropup: true }

            return {}
        }
    },
    props: {
        color: { type: String, default: 'secondary' },
        disabled: { type: Boolean, default: false },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean, default: false },
        menuClass: { type: String },
        noCaret: { type: Boolean },
        outline: { type: Boolean, default: false },
        position: { type: String, default: '' },
        right: { type: Boolean },
        small: { type: Boolean, default: false },
        text: { type: String },
    }
}
</script>